import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoicePopup = loadAsyncComponent(() => import('./Container'), 'popup');
